import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-http-backend';
import { URLS } from './urls';
import SupportedLanguageDetector from './utils/SupportedLanguageDetector';
import { supportedLanguages } from './utils/language';

const languageDetector = new SupportedLanguageDetector();

i18n
  .use(Backend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    whitelist: supportedLanguages,
    nonExplicitWhitelist: true,
    load: 'languageOnly',
    fallbackLng: 'de',
    debug: false,
    backend: {
      loadPath: URLS['BACKEND'] + '/api/translations/{{lng}}.json'
    },
    detection: {
      order: ['querystring', 'localStorage', 'cookie', 'navigator'],
      lookupQuerystring: 'lng',
      caches: ['localStorage', 'cookie']
    },
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js